module.exports = __webpack_public_path__ + "img/ic_capture.399b915e.svg";